import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const editExpirationDateDialogStyle = () => ({
	expirationDateWrapper: {
		marginTop: '32px',
		height: '400px',
		'& > div': {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'flex-end',
		},
		'& label': {
			marginBottom: '4px',
			marginRight: 0,
			'& .MuiFormControlLabel-label': {
				position: 'relative',
				top: '3px',
			},
		},
	},
	dialogBodyWrapper: {
		width: '325px',
		maxWidth: '80%',
		margin: '40px auto 0',
	},
	userInfoWrapper: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'center',
		'& > div': {
			'&:first-of-type': {
				'& svg': {
					height: '64px',
					width: '64px',
					color: blackColors[4],
					marginRight: '14px',
				},
			},
			'&:last-of-type': {
				'& p': {
					marginBottom: 0,
				},
			},
		},
	},
	dialogWrapper: {
		'& .MuiPaper-root': {},
	},
});

export default editExpirationDateDialogStyle;
